module.exports = __webpack_public_path__ + "e6f29a91.png";


//////////////////
// WEBPACK FOOTER
// ./public/icons/002-protection-shield-with-a-check-mark.png
// module id = 1470
// module chunks = 4